import axios from "axios";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import "../../../App.css";
import Item from "./ItemsInCart";
// import Orders2 from "./Orders2";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import { getGlobalVar } from "../../config/Config"; // added a new branch
import Customer from "../customers/Customer";
import CustomerNote from "./CustomerNote";
import InternalNote from "./InternalNote";
import OrderNav from "./OrderNav";
import Payment from "./Payment";

const CreateOrderForm = ({ mode }) => {
  // replace with your server URL

  const SOCKET_SERVER_URL =
    process.env.REACT_APP_SOCKET_SERVER_URL || "http://defcon:5000";
  const socket = io(SOCKET_SERVER_URL);

  useEffect(() => {
    // Listen for messages from server
    socket.on("receive_message", (msg) => {
      const id = localStorage.getItem("actualOrderId");
      ////console.log(msg);

      if (id == msg) {
        resume();
      }
      //console.log("message");
    });

    socket.on("receive_new_order", (msg) => {
      //console.log(msg);
    });

    // Cleanup on unmount
    return () => {
      socket.disconnect();
    };
  }, []);

  const count = useSelector((state) => state.counter.count);
  const dispatch = useDispatch();

  // const handleIncrement = () => {
  //   dispatch(increment(5)); // Pass 5 as a parameter to increment
  // };

  // const handleDecrement = () => {
  //   dispatch(decrement(3)); // Pass 3 as a parameter to decrement
  // };
  // const orders = useSelector((state) => state.orders.orders); // Access Redux state
  // URLS || API
  const baseurl = getGlobalVar().url;
  //const USER = JSON.parse(localStorage.getItem("user"));
  const auth = JSON.parse(localStorage.getItem("auth"));
  const org = "?org=" + auth?.org;
  const categoriesUrl = baseurl + "/accountingapi/GetProductCategories/" + org;
  const OrderAPI = baseurl + "/posapi/GetOrder/";
  const OrderedProductAPI = baseurl + "/posapi/CreateOrder/";
  const GetOrderedProducts =
    baseurl +
    "/posapi/GetOrderedProducts" +
    org +
    "&is_archive=false" +
    "&order_ref=";
  // const paymentAPI =baseurl+ "/posapi/GetPayment/"+org;
  const customersAPI = baseurl + "/accountingapi/GetVendors" + org;
  const productsUrl =
    baseurl + "/accountingapi/GetProduct/" + org + "&is_archive=false";
  const imgUrl = baseurl + "";
  const OrderedProductsAPI =
    baseurl +
    "/posapi/GetOrderedProducts" +
    org +
    "&is_archive=false" +
    "&order_ref=";
  const API_URL = baseurl + "/posapi/GetOrder/" + org + "&status=false";
  const [globalVar, setValue] = useState(getGlobalVar());

  const [allProducts, setAllProducts] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [itemsInCart, setItemsInCart] = useState([]);
  const [calVal, setCalVal] = useState("");
  const [selectedItemId, setSelectedItemId] = useState();
  const [searchTerm, setSearchTerm] = useState([]);
  const [payments, setpayments] = useState();
  // const [updatedPrice, setUpdatedPrice] = useState({});
  // const [updatedQty, setUpdatedQty] = useState();

  //  TOTAL price
  let [total, setTotal] = useState("");

  const [showPopup, setShowPopup] = useState(false);

  // Customer State
  const [customerToggle, setCustomerToggle] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [currentCustomer, setCurrentCustomer] = useState(null);
  const [prevCustomer, setPrevCustomer] = useState([]);
  const [prevOrder, setPrevOrder] = useState([]);

  // Boolean State
  const [payPopup, setPayPopup] = useState(false);
  const [qtySelect, setQtySelect] = useState(false);
  const [discSelect, setDiscSelect] = useState(false);
  const [priceSelect, setPriceSelect] = useState(false);
  const [equalsSelect, setEqualsSelect] = useState(false);
  const [allView, setAllView] = useState(true);
  // //console.log(globalVar.Token,"Tokennnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn")
  useEffect(() => {
    //console.log("calculator button value 0");
    setCalVal("0");
  }, [selectedItemId]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(categoriesUrl, {
          headers: {
            Authorization: "Bearer " + globalVar.Token,
          },
        });
        setCategories(res.data);
      } catch (error) {
        //console.log(error);
      }
    };

    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${productsUrl}`, {
          headers: {
            Authorization: "Bearer " + globalVar.Token,
          },
        });
        const fetchedProducts = res.data.map((product) => ({
          ...product,
          //Photo: `{product.Photo}`, // Prepend the base URL for images
        }));
        setAllProducts(fetchedProducts);
        setSearchResults(fetchedProducts);

        const savedOrders = JSON.parse(localStorage.getItem("orders")) || [];
        setPrevOrder(savedOrders);
      } catch (error) {
        //console.log(error);
      }
    };

    const fetchCustomers = async () => {
      try {
        const customerRes = await axios.get(customersAPI, {
          headers: {
            Authorization: "Bearer " + globalVar.Token,
          },
        });
        setCustomerData(customerRes.data);
      } catch (error) {
        //console.log("Error fetching customers:", error);
      }
    };

    // const fetchPayments = async () => {
    //   try {
    //     const res = await axios.get(paymentAPI, {
    //       headers: {
    //         Authorization: "Bearer " +globalVar.Token,
    //       },
    //     });
    //     setpayments(res.data);
    //   } catch (error) {
    //     //console.log(error);
    //   }
    // };

    fetchCategories();
    fetchProducts();
    fetchCustomers();
    // fetchPayments()
  }, []);

  const [currentOrderRef, setCurrentOrderRef] = useState("");
  const resume = async () => {
    // resume order after refresh
    //console.log("resume order after refresh");
    try {
      const id = localStorage.getItem("actualOrderId");
      // Find the selected order in the orders state
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      });
      // Filter orders where status is false
      const filteredOrders = response.data.filter((order) => !order.status);
      const orders = filteredOrders;
      //console.log("filtered orders: ", filteredOrders);
      //console.log(id, "=======actual order id to id=========");
      const selectedOrder = orders.find((order) => order.id == id);
      //console.log(orders, "======= order=========");
      //console.log(selectedOrder, "=======selected order=========");

      if (id != undefined) {
        if (selectedOrder) {
          // Set the current customer from the selected order
          //console.log("selectedOrder", selectedOrder);
          const selectedCustomer = await customerData.find(
            (customer) => customer.id === selectedOrder.customer
          );

          /* console.log(
            customerData,
            selectedCustomer,
            "-------------------selectedCustomer"
          ); */
          localStorage.setItem("actualOrderId", selectedOrder.id);
          const orderRef = localStorage.getItem("actualOrderId");
          // const orderRef = selectedOrder.id;
          const orderedProductsResponse = await axios.get(
            `${OrderedProductsAPI}${orderRef}`,
            {
              headers: {
                Authorization: "Bearer " + globalVar.Token,
              },
            }
          );

          const orderedProducts = orderedProductsResponse.data;
          const productsWithDetails = await Promise.all(
            orderedProducts.map(async (orderedProduct) => {
              //console.log(orderedProducts, "orderedProducts sahib");
              // const product = allProducts.find(p => p.id === orderedProduct.product.id);
              const product = orderedProduct.product;
              product.Photo = globalVar.url + product.Photo;
              /* console.log(
                "filtering products",
                product,
                "=========================="
              ); */
              return {
                ...product,
                quantity: orderedProduct.quantity,
                price: orderedProduct.price || product.SalesPrice,
                discount: orderedProduct.discount || 0,
              };
            })
          );
          // const total = productsWithDetails.reduce((acc, item) => acc + (item.price * item.Quantity), 0);
          setItemsInCart(productsWithDetails);
          setTotal(total);

          setCurrentCustomer(selectedCustomer);
          // setCurrentOrderRef(selectedOrder.id);
          //console.log("order ref", orderRef);
          //console.log("previous order ", prevOrder);
          //console.log("products with details", productsWithDetails);
          setShowPopup(false);
          // setOrders(orders.filter((order) => order.id !== id));
          setPrevOrder(prevOrder);
        } else {
          console.error("Selected order not found in the orders list.");
          localStorage.removeItem("actualOrderId");
        }
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  useEffect(() => {
    //console.log(customerData, "==========current customer================");
    resume();
  }, [customerData]);
  const calculateTotal = (items) => {
    //console.log(items, "items");
    let newTotal = 0;
    items.forEach((item) => {
      const itemTotal = (item.quantity || 0) * (item.price || item.SalesPrice);
      const discountAmount = (item.discount / 100) * itemTotal || 0;
      newTotal += itemTotal - discountAmount;
    });
    return newTotal;
  };

  useEffect(() => {
    // //console.log(typeof(newOrderRef))
    setTotal(calculateTotal(itemsInCart));
    //console.log("TOTALupdated");
  }, [itemsInCart, setItemsInCart]);

  const fetchProductsByCategory = async (categoryId) => {
    try {
      const res = await axios.get(`${productsUrl}`, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      });
      //console.log(res.data); // Log the response to check its structure

      // If the API returns a single product object
      const product = res.data; // Adjust if `data` contains the product directly

      if (product && Array.isArray(product)) {
        const fetchedProducts = product.map((p) => ({
          ...p,
          //Photo: `${imgUrl}${p.Photo}`,
        }));
        setAllProducts(fetchedProducts);
      } else if (product) {
        // Handle a single product object response
        const fetchedProducts = [
          {
            ...product,
            //Photo: `${imgUrl}${product.Photo}`,
          },
        ];
        setAllProducts(fetchedProducts);
      } else {
        console.error(
          "API response does not contain a product array:",
          product
        );
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const updateCartItems = async (orderRef) => {
    try {
      const orderedProductsResponse = await axios.get(
        `${GetOrderedProducts}${orderRef}`,
        {
          headers: {
            Authorization: "Bearer " + globalVar.Token,
          },
        }
      );

      const orderedProducts = orderedProductsResponse.data;
      const productsWithDetails = await Promise.all(
        orderedProducts.map(async (orderedProduct) => {
          const product = allProducts.find(
            (p) => p.id === orderedProduct.product.id
          );
          return {
            ...product,
            quantity: orderedProduct.quantity,
            discount: orderedProduct.discount || 0,
            price: orderedProduct.price,
          };
        })
      );
      setItemsInCart(productsWithDetails);
    } catch (error) {
      console.error("Error fetching ordered products:", error);
    }
  };

  // On category click
  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
    if (categoryId) {
      fetchProductsByCategory(categoryId);
    } else {
      // Optionally, you can fetch all products if no category is selected
      // fetchProducts();
      //console.log(`no category selected`);
    }
  };

  const filteredProducts = selectedCategory
    ? allProducts.filter((product) => {
        /* console.log(
          `Filtering product: ${product.id} ${product.ProductCategories}`
        ); */
        return (
          product.ProductCategories &&
          product.ProductCategories === selectedCategory
        );
      })
    : allProducts;

  // Products and categories display
  const showAllProducts = () => {
    setAllView(true);
    setSelectedCategory(null);
  };

  const OrderedProduct = async (product, orderRef) => {
    //console.log("OrderedProduct", orderRef);
    try {
      const orderData = {
        date: new Date().toISOString().split("T")[0],
        quantity: 1,
        discount: 0,
        price: product.SalesPrice,
        order_ref: orderRef,
        product: product.id,
      };

      const response = await axios.post(
        `${OrderedProductAPI}` + org,
        orderData,
        {
          headers: {
            Authorization: "Bearer " + globalVar.Token,
          },
        }
      );

      //console.log("Orderedproduct sent to backend:", response.data);
    } catch (error) {
      console.error(
        "Error sending order to backend:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const updateOrderProduct = async (productId, orderRef, data) => {
    //console.log("updateordered product");
    try {
      const orderedProductsResponse = await axios.get(
        `${GetOrderedProducts}${orderRef}`,
        {
          headers: { Authorization: "Bearer " + globalVar.Token },
        }
      );

      const orderedProduct = orderedProductsResponse.data.find(
        (orderedProduct) => orderedProduct.product.id === productId
      );

      if (orderedProduct) {
        await axios.patch(
          `${OrderedProductAPI}${orderedProduct.id}/` + org,
          data,
          {
            headers: { Authorization: "Bearer " + globalVar.Token },
          }
        );
        //console.log(`Updated product ID: ${productId} with data:`, data);
      } else {
        console.error("Ordered product not found");
      }
    } catch (error) {
      console.error(
        "Error updating product details:",
        error.response ? error.response.data : error.message
      );
    }
  };
  const nextSteps = async (id, orderRef) => {
    const productToAdd = allProducts.find((product) => product.id === id);

    /* console.log(
      productToAdd,
      "=========products to add======================="
    ); */
    //console.log(orderRef, "================================");
    let productAlreadyPresent = itemsInCart.find(
      (item) => item.id === productToAdd.id
    );

    if (productAlreadyPresent) {
      const newQuantity = productAlreadyPresent.quantity + 1;
      setItemsInCart(
        itemsInCart.map((item) => {
          return item.id !== productAlreadyPresent.id
            ? item
            : {
                ...productAlreadyPresent,
                quantity: newQuantity,
              };
        })
      );
      await updateOrderProduct(id, orderRef, { quantity: newQuantity });
    } else {
      setItemsInCart([...itemsInCart, { ...productToAdd, quantity: 1 }]);
      OrderedProduct(productToAdd, orderRef);
    }
    setTotal(
      calculateTotal([...itemsInCart, { ...productToAdd, quantity: 1 }])
    );

    const socket = io(SOCKET_SERVER_URL);
    socket.emit("send_message", orderRef);
  };
  // Cart Items ADD
  const onProductClick = async (id) => {
    //console.log("on product click");
    const orderRef = localStorage.getItem("actualOrderId");
    //console.log(orderRef);
    if (orderRef == undefined) {
      sendOrderToBackend().then((val) => {
        //console.log("after order sended");
        const genorderRef = localStorage.getItem("actualOrderId");
        //console.log(genorderRef);
        nextSteps(id, genorderRef);
      });
    } else {
      //console.log(orderRef);

      nextSteps(id, orderRef);
    }
  };

  // On QTY Select
  const onQtySelect = () => {
    setQtySelect(true);
    setPriceSelect(false);
    setDiscSelect(false);
    setCalVal("");
  };
  const onPriceSelect = () => {
    setQtySelect(false);
    setPriceSelect(true);
    setDiscSelect(false);
    setCalVal("");
  };
  const onDiscSelect = () => {
    setQtySelect(false);
    setPriceSelect(false);
    setDiscSelect(true);
    setCalVal("");
  };

  const updateValue = (field, selectedItemId, newValue) => {
    //console.log("update value triggered");
    const orderRef = localStorage.getItem("actualOrderId") || currentOrderRef;
    const item = itemsInCart.find((product) => selectedItemId === product.id);
    if (!item) return;

    let updatedObj = { ...item, [field]: Number(newValue) };

    // Update frontend first
    setItemsInCart(
      itemsInCart.map((product) =>
        product.id === selectedItemId ? updatedObj : product
      )
    );

    // Update backend next
    if (field === "quantity") {
      updateOrderProduct(item.id, orderRef, { quantity: updatedObj.quantity });
    } else {
      updateOrderProduct(item.id, orderRef, { [field]: updatedObj[field] });
    }
    // Recalculate the total dynamically after updating the item
    setTotal(
      calculateTotal(
        itemsInCart.map((item) =>
          item.id === selectedItemId ? updatedObj : item
        )
      )
    );
  };

  // Calculator Button CLick
  const onCalcBtnClick = async (e) => {
    const newCalVal = calVal.concat(e.target.name);
    if (qtySelect) {
      await updateValue("quantity", selectedItemId, newCalVal);
      setItemsInCart((prevItems) =>
        prevItems.map((item) =>
          item.id === selectedItemId
            ? { ...item, quantity: parseFloat(newCalVal) }
            : item
        )
      );
    }
    if (priceSelect) {
      await updateValue("price", selectedItemId, newCalVal);
      // Update the price along with price
      setItemsInCart((prevItems) =>
        prevItems.map((item) =>
          item.id === selectedItemId
            ? { ...item, price: parseFloat(newCalVal) }
            : item
        )
      );
    }
    if (discSelect) {
      let discountValue = Math.min(Number(newCalVal), 100);
      await updateValue("discount", selectedItemId, discountValue);
      setItemsInCart((prevItems) =>
        prevItems.map((item) =>
          item.id === selectedItemId
            ? { ...item, discount: parseFloat(newCalVal) }
            : item
        )
      );
    }
    setCalVal(newCalVal);
    setTotal(calculateTotal(itemsInCart));
  };

  // Delete quantity or Price
  const onCalcDel = async () => {
    //console.log(selectedItemId);
    let itemToChange = itemsInCart.find((item) => item.id === selectedItemId);

    if (qtySelect) {
      let updatedItem = { ...itemToChange, quantity: 0 };
      setItemsInCart(
        itemsInCart.map((item) =>
          item.id === selectedItemId ? updatedItem : item
        )
      );
      await updateValue("quantity", selectedItemId, 0);
    } else if (discSelect) {
      let updatedItem = { ...itemToChange, discount: 0 };
      setItemsInCart(
        itemsInCart.map((item) =>
          item.id === selectedItemId ? updatedItem : item
        )
      );
      await updateValue("discount", selectedItemId, 0);
    } else if (priceSelect) {
      let updatedItem = { ...itemToChange, price: 0 };
      setItemsInCart(
        itemsInCart.map((item) =>
          item.id === selectedItemId ? updatedItem : item
        )
      );
      await updateValue("price", selectedItemId, 0);
    }

    setCalVal("");
  };

  const updateOrderCustomer = async (orderId, customerId) => {
    try {
      const response = await axios.patch(
        `${OrderAPI}${orderId}/` + org,
        { customer: customerId },
        {
          headers: {
            Authorization: "Bearer " + globalVar.Token,
          },
        }
      );
      //console.log("Customer updated in order:", response.data);
    } catch (error) {
      console.error(
        "Error updating customer in order:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const onCustomerClick = async (id) => {
    const selectedCustomer = customerData.find(
      (customer) => customer.id === id
    );
    setCurrentCustomer(selectedCustomer);
    const actualOrderId = localStorage.getItem("actualOrderId");

    await updateOrderCustomer(actualOrderId, selectedCustomer.id);
    setCustomerToggle(false);
  };

  const onCustomerNameClick = async () => {
    setCustomerToggle(true);
  };

  // Internal Note State
  const [showInternalNotePopup, setShowInternalNotePopup] = useState(false);

  // Customer Note State
  const [showCustomerNotePopup, setShowCustomerNotePopup] = useState(false);

  const applyInternalNote = (note) => {
    setItemsInCart(
      itemsInCart.map((item) =>
        item.id === selectedItemId ? { ...item, internalNote: note } : item
      )
    );
  };

  const applyCustomerNote = (note) => {
    setItemsInCart(
      itemsInCart.map((item) =>
        item.id === selectedItemId ? { ...item, customerNote: note } : item
      )
    );
  };

  const sendOrderToBackend = async () => {
    try {
      // Create the order
      const newOrderRef = uuidv4();

      const order = {
        order_ref: newOrderRef,
        date: new Date().toISOString().split("T")[0],
        session: "01",
        fiscal_position: "office",
        status: false,
        User: 1,
      };

      const response = await axios.post(OrderAPI + org, order, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      });
      //console.log("Order sent to backend:", response.data);

      // Store the actual order ID
      const actualOrderId = response.data.id;
      localStorage.setItem("actualOrderId", actualOrderId);

      socket.emit("send_new_order", response.data);

      // Update the order with the customer information
      if (currentCustomer) {
        await updateOrderCustomer(actualOrderId, currentCustomer.id);
      }

      // for (let item of itemsInCart) {
      //   await OrderedProduct(item.id, actualOrderId);
      // }
      // setShowPopup(false);
      setItemsInCart([]);
      setCurrentOrderRef(newOrderRef);
      setCurrentCustomer(null);
      setShowPopup(false);
    } catch (error) {
      console.error(
        "Error sending order to backend:",
        error.response ? error.response.data : error.message
      );
      return false;
    }
  };

  return (
    <>
      <OrderNav
        itemsInCart={itemsInCart}
        setItemsInCart={setItemsInCart}
        currentCustomer={currentCustomer}
        setCurrentCustomer={setCurrentCustomer}
        prevOrder={prevOrder}
        setPrevOrder={setPrevOrder}
        prevCustomer={prevCustomer}
        setPrevCustomer={setPrevCustomer}
        allProducts={allProducts}
        searchResults={searchResults}
        setSearchResults={setSearchResults}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setAllView={setAllView}
        setTotal={setTotal}
        sendOrderToBackend={sendOrderToBackend}
        setCurrentOrderRef={setCurrentOrderRef}
        customerData={customerData}
      />

      <div className="main-div-create-order flex">
        <div className="left ">
          {/* ITEMS IN CART */}
          <div className="items-ul">
            <ul className="items-in-cart">
              {Array.isArray(itemsInCart) &&
                itemsInCart.map((item) => (
                  <Item
                    key={item.id}
                    imgUrl={imgUrl}
                    item={item}
                    itemsInCart={itemsInCart}
                    setItemsInCart={setItemsInCart}
                    calVal={calVal}
                    selectedItemId={selectedItemId}
                    setSelectedItemId={setSelectedItemId}
                    total={total}
                    setTotal={setTotal}
                  />
                ))}
            </ul>
          </div>
          <div className="total">Total {total} </div>
          <div className="additionals">
            <div className="additionals-item">
              {/* Customer */}
              <div className="customer">
                <button
                  type="button"
                  onClick={onCustomerNameClick}
                  className=""
                >
                  <div className="cust-icon-text">
                    <span className="">
                      {currentCustomer && typeof currentCustomer === "object"
                        ? `${currentCustomer.Name}`
                        : currentCustomer
                        ? `${currentCustomer}`
                        : "Select Customer"}
                    </span>
                  </div>
                </button>
              </div>
              {/* Customer component render */}
              {customerToggle && (
                <Customer
                  setCustomerToggle={setCustomerToggle}
                  customerData={customerData}
                  setCustomerData={setCustomerData}
                  setCurrentCustomer={setCurrentCustomer}
                  onCustomerClick={onCustomerClick}
                />
              )}
            </div>

            {/* Internal Note */}
            <div className="additionals-item">
              <div className="internal-note">
                <button
                  type="button"
                  onClick={() => setShowInternalNotePopup(true)}
                >
                  Internal Note
                </button>
                {showInternalNotePopup && (
                  <InternalNote
                    setShowNotePopup={setShowInternalNotePopup}
                    applyNote={applyInternalNote}
                  />
                )}
              </div>
            </div>
            {/* Customer Note */}
            <div className="additionals-item">
              <div className="customer-note">
                <button
                  type="button"
                  onClick={() => setShowCustomerNotePopup(true)}
                >
                  Customer Note
                </button>
                {showCustomerNotePopup && (
                  <CustomerNote
                    setShowNotePopup={setShowCustomerNotePopup}
                    applyNote={applyCustomerNote}
                  />
                )}
              </div>
            </div>
          </div>
          {mode === "createorder" && (
            <div className="bottom-left">
              {/* Payment */}
              <div className="pay col-3">
                <button
                  onClick={() => {
                    setPayPopup(true);
                  }}
                  className="flex flex-col"
                  style={{ background: "transparent", border: "none" }}
                >
                  <div className="pay-icon-text">
                    <img
                      className=" pay-icon ml-2 "
                      alt="cust"
                      src={
                        require("../../../assets/images/credit-card-payment.svg")
                          .default
                      }
                    />
                    <span className="payment-btn">Payment</span>{" "}
                  </div>
                </button>
                {payPopup ? (
                  <Payment
                    itemsInCart={itemsInCart}
                    currentCustomer={currentCustomer}
                    prevOrder={prevOrder}
                    currentOrderRef={currentOrderRef}
                    total={total}
                    setTotal={setTotal}
                    setPayPopup={setPayPopup}
                    payPopup={payPopup}
                    setItemsInCart={setItemsInCart}
                  />
                ) : (
                  ""
                )}
              </div>
              {/* Calculator */}
              <div className="calculator">
                <button name="1" onClick={onCalcBtnClick}>
                  {" "}
                  1{" "}
                </button>
                <button name="2" onClick={onCalcBtnClick}>
                  {" "}
                  2{" "}
                </button>
                <button name="3" onClick={onCalcBtnClick}>
                  {" "}
                  3{" "}
                </button>
                <button
                  name="QTY"
                  className={`qty ${qtySelect ? "btn-selected" : ""}`}
                  onClick={onQtySelect}
                >
                  Qty
                </button>
                <button name="4" onClick={onCalcBtnClick}>
                  {" "}
                  4{" "}
                </button>
                <button name="5" onClick={onCalcBtnClick}>
                  {" "}
                  5{" "}
                </button>
                <button name="6" onClick={onCalcBtnClick}>
                  {" "}
                  6{" "}
                </button>
                <button
                  name="DISC"
                  className={`disc ${discSelect ? "btn-selected" : ""}`}
                  onClick={onDiscSelect}
                >
                  Disc
                </button>
                <button name="7" onClick={onCalcBtnClick}>
                  {" "}
                  7{" "}
                </button>
                <button name="8" onClick={onCalcBtnClick}>
                  {" "}
                  8{" "}
                </button>
                <button name="9" onClick={onCalcBtnClick}>
                  9{" "}
                </button>
                <button
                  name="price"
                  className={`price ${priceSelect ? "btn-selected" : ""}`}
                  onClick={onPriceSelect}
                >
                  Price
                </button>
                <button name="." onClick={onCalcBtnClick}>
                  {" "}
                  .{" "}
                </button>
                <button name="0" onClick={onCalcBtnClick}>
                  {" "}
                  0{" "}
                </button>
                <button name="=" onClick={onCalcBtnClick}>
                  {" "}
                  ={" "}
                </button>
                <button name="x" onClick={onCalcDel}>
                  {" "}
                  X{" "}
                </button>
              </div>
            </div>
          )}
        </div>

        {mode === "createorder" && (
          <div className="right">
            {/* Nav */}
            <nav className=" justify-between border-2">
              <ul
                className="categories w-full p-1 m-0"
                style={{ justifyContent: "space-around" }}
              >
                <li>
                  <button className=" " onClick={showAllProducts}>
                    {" "}
                    All Products{" "}
                  </button>
                </li>
                {categories.map((category) => (
                  <li key={category.id}>
                    <button
                      className={`${
                        selectedCategory === category.id ? "selected" : ""
                      }`}
                      onClick={() => handleCategoryClick(category.id)}
                    >
                      {category.CategoryName}
                    </button>
                  </li>
                ))}
              </ul>
              {/* Search bar */}
            </nav>
            <div className="products-data p-2">
              {/* test redux */}

              {/* <h1>{count}</h1> */}
              {/* <button onClick={() => dispatch({ type: 'INCREMENT' })}>Increment</button>
      <button onClick={() => dispatch({ type: 'DECREMENT' })}>Decrement</button> */}
              {searchTerm.length > 0 && searchResults.length < 10
                ? searchResults.map((product) => (
                    <button
                      key={product.id}
                      onClick={() => {
                        onProductClick(product.id);
                      }}
                    >
                      <div className="prod-dat-img-text flex-col align-center">
                        <img src={product.Photo} alt={product.ProductName} />
                        <span> Name: {product.ProductName}</span>
                        <span>Price: {product.SalesPrice}</span>
                      </div>
                    </button>
                  ))
                : filteredProducts.map((product) => (
                    <button
                      key={product.id}
                      onClick={() => {
                        onProductClick(product.id);
                      }}
                    >
                      <div className="prod-dat-img-text flex-col align-center">
                        <img src={product.Photo} alt={product.ProductName} />
                        <span> Name: {product.ProductName}</span>
                        <br />
                        <span>Price: {product.SalesPrice}</span>
                      </div>
                    </button>
                  ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default CreateOrderForm;
